import React, { useState } from 'react';
import {
  Button,
  Icon,
  Modal,
  Table
} from 'semantic-ui-react';

const UserDetailConfig = ({ config }) => {
  const [open, setOpen] = useState(false);

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      closeOnDimmerClick={false}
      trigger={
        <Button icon disabled={Object.keys(config).length === 0}>
          <Icon name='ellipsis horizontal' />
        </Button>
      }
    >
      <Modal.Header>Additional Config</Modal.Header>
      <Modal.Content>
        <Table basic='very' inverted>
          <Table.Body>
            {Object.keys(config).map((key) => (
              <Table.Row>
                <Table.Cell width={2}>
                  {key}
                </Table.Cell>
                <Table.Cell>
                  {Array.isArray(config[key]) ?
                    config[key].length === 0 ? '[Empty]' : config[key].join(', ')
                  :
                    JSON.stringify(config[key])
                  }
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Modal.Content>
      <Modal.Actions>
        <Button primary onClick={() => { setOpen(false); }}>
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  )
};

export default UserDetailConfig;
